export default __webpack_public_path__ + "static/media/ag_10.b62b6e3c.wav";